<template>
  <v-card justify-center width="700px" elevation="0">
    <!-- loaging -->
    <v-overlay :value="overlay">
      <img
        :src="require('@/Arquivos/onload.gif')"
        style="width: 70px; height: 70px"
      />
    </v-overlay>
    <!-- loaging -->
    <!-- MENSAGEM -->
    <v-snackbar elevation="13" v-model="alert">
      {{ msgAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="fecharAlert()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- MENSAGEM -->
    <v-alert class="text-center" color="blue" elevation="5">
      <strong style="color: white">Cadastro de Perfil</strong>
      <v-fab-transition>
        <v-btn
          v-show="objSlide > 1"
          color="#feca26"
          fab
          dark
          absolute
          bottom
          left
          v-if="objSlide != 1"
          @click="objSlide = objSlide - 1"
        >
          <v-icon large color="black">mdi-reply</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-alert>
    <v-dialog v-model="dialogImagem">
      <div class="mt-4 mx-auto">
        <div class="d-flex flex-column justify-space-between align-center">
          <v-img
            :aspect-ratio="16 / 9"
            :height="widthImagem"
            :width="widthImagem"
            :src="arquivo"
          >
            <v-row>
              <v-col cols="7" sm="7" md="7">
                <v-btn
                  :loading="btnDisabled"
                  @click="
                    abrirSelecaoImagem();
                    dialogImagem = false;
                  "
                  color="success"
                  class="ma-2"
                  large
                >
                  Alterar Imagem
                </v-btn>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-btn
                  color="warning"
                  @click="dialogImagem = false"
                  class="ma-2"
                  large
                >
                  FECHAR
                </v-btn>
              </v-col>
            </v-row>
          </v-img>
        </div>
      </div>
    </v-dialog>

    <v-stepper class="elevation-0" align="center" v-model="objSlide">
      <!-- CABEÇALHO-->
      <v-stepper-header>
        <v-stepper-step :complete="objSlide > 1" step="1"></v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="objSlide > 2" step="2"></v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3"></v-stepper-step>
      </v-stepper-header>
      <!-- CABEÇALHO-->

      <!-- Primeira Parte Cadastro -->
      <v-stepper-content step="1">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- IMAGEM -->

          <v-col cols="12" sm="12" md="12">
            <div
              class="base-image-input"
              :style="{ 'background-image': `url(${arquivo})` }"
              @click="perfil.img ? (dialogImagem = true) : abrirSelecaoImagem()"
            >
              <span
                v-if="!arquivo"
                class="placeholder"
                align="center"
                height="150"
                width="70"
              >
                <img
                  :src="require('@/Arquivos/imagemClick.gif')"
                  style="width: 180px; height: 180px"
                />
              </span>
              <input
                class="file-input"
                ref="fileInput"
                type="file"
                @input="quandoSelecionarImagem"
              />
            </div>
          </v-col>

          <!-- IMAGEM -->
          <v-divider style="border: 8px solid white"></v-divider>

          <v-text-field
            background-color="#2196f3"
            filled
            hide-details
            dense
            auto-grow
            label="Primeiro Nome"
            class="purple-input"
            required
            :rules="primeiroNomeRules"
            v-model="perfil.primeiroNome"
          />
          <v-divider style="border: 8px solid white"></v-divider>

          <v-text-field
            background-color="#2196f3"
            no-resize
            hide-details
            rows="3"
            filled
            dense
            label="Segundo Nome"
            required
            :rules="segundoNomeRules"
            v-model="perfil.segundoNome"
          />

          <v-col cols="12" sm="12" md="12">
            <v-btn
              :loading="btnDisabled"
              @click="atualizarFoto()"
              color="success"
              class="ma-2"
              x-large
            >
              Próximo
            </v-btn>

            <v-btn color="warning" @click="deslogarUsuario" class="ma-2" large>
              sair
            </v-btn>
          </v-col>
        </v-form>
      </v-stepper-content>
      <!-- Primeira Parte Cadastro -->

      <!-- Segunda Parte Cadastro -->
      <v-stepper-content step="2">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-autocomplete
            auto-select-first
            solo
            :items="sexos"
            background-color="#2196f3"
            filled
            hide-details
            auto-grow
            label="Sexo"
            class="purple-input"
            required
            :rules="sexoRules"
            v-model="perfil.sexo"
          ></v-autocomplete>
          <v-divider style="border: 8px solid white"></v-divider>
          <v-text-field
            background-color="#2196f3"
            filled
            hide-details
            auto-grow
            label="Data de Nascimento"
            class="purple-input"
            required
            v-model="perfil.dataNascimento"
            :rules="dataNascimentoRules"
            v-mask="'##/##/####'"
          />
          <v-divider style="border: 8px solid white"></v-divider>
          <v-text-field
            background-color="#2196f3"
            no-resize
            hide-details
            rows="3"
            filled
            label="Telefone"
            required
            v-model="perfil.telefone"
            :rules="telefoneRules"
            v-mask="'(##)#####-####'"
          />
          <v-divider style="border: 8px solid white"></v-divider>
          <v-autocomplete
            auto-select-first
            solo
            hide-details
            :items="profissoes"
            background-color="#2196f3"
            filled
            auto-grow
            label="Profissao"
            class="purple-input"
            required
            v-model="perfil.profissao"
            :rules="profissaoRules"
          ></v-autocomplete>
          <v-divider style="border: 8px solid white"></v-divider>

          <v-col cols="12" sm="12" md="12">
            <v-btn
              :loading="btnDisabled"
              @click="objSlide = 3"
              color="success"
              class="ma-2"
              x-large
            >
              Próximo
            </v-btn>

            <v-btn color="warning" @click="deslogarUsuario" class="ma-2" large>
              sair
            </v-btn>
          </v-col>
        </v-form>
      </v-stepper-content>
      <!-- Segunda Parte Cadastro -->

      <!-- Terceira Parte Cadastro  Maps-->
      <v-stepper-content step="3">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- MAPS -->
          <v-card
            class="mt-4 mx-auto"
            elevation="9"
            width="710px"
            color="#2196f3"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="cyan"
              max-width="calc(100% - 32px)"
            >
              <gmap-map
                :center="center"
                :zoom="13"
                style="width: 680x; height: 170px"
              >
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  @click="center = m.position"
                ></gmap-marker>
              </gmap-map>
            </v-sheet>

            <v-card color="#e0e0e090" style="width: 98%; height: 50px">
              <!-- CAMPO TEXTO -->
              <gmap-autocomplete
                style="width: 98%; height: 50px; font-size: 16px"
                @place_changed="setPlace"
                :value="''"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
                :placeholder="'  Pesquise sua localização ...'"
              />
              <!-- CAMPO TEXTO -->
            </v-card>
            <v-alert dense type="info" icon="mdi-map-marker-radius-outline">
              {{ EnderecoPersonalizado }}
            </v-alert>
          </v-card>
          <!-- MAPS -->

          <v-col cols="12" sm="12" md="12">
            <v-btn
              :loading="btnDisabled"
              @click="validaSalvarEditar(perfil.id)"
              color="success"
              class="ma-2"
              x-large
            >
              Salvar
            </v-btn>

            <v-btn color="warning" @click="deslogarUsuario" class="ma-2" large>
              sair
            </v-btn>
          </v-col>
        </v-form>
      </v-stepper-content>
      <!-- Terceira Parte Cadastro  Maps-->
    </v-stepper>
  </v-card>
</template>

<script>
import { storage } from "@/main";
import firebase from "firebase";
// import moment from "moment";

export default {
  name: "GoogleMap",

  data() {
    return {
      dialogImagem: false,
      widthImagem: 450,
      mask: "##/##/####",
      overlay: false,
      objSlide: 1,

      alert: false,
      msgAlert: "",
      arquivo: null,
      valid: false,
      btnDisabled: false,

      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      EnderecoPersonalizado: "",
      user: null,

      primeiroNomeRules: [
        (v) => !!v || "Obrigatória",
        (v) => v.length <= 30 || "maximo 25 Caractéres",
      ],
      segundoNomeRules: [(v) => !!v || "Obrigatório"],
      sexoRules: [(v) => !!v || "Obrigatório"],
      dataNascimentoRules: [(v) => !!v || "Obrigatório"],
      telefoneRules: [(v) => !!v || "Obrigatório"],
      profissaoRules: [(v) => !!v || "Obrigatório"],
      emailRules: [(v) => !!v || "Obrigatório"],

      perfil: {
        id: "",
        email: "",
        primeiroNome: "",
        segundoNome: "",
        dataNascimento: "",
        endereco: "",
        bairro: "",
        cidade: "",
        regiao: "",
        longitude: "",
        latitude: "",
        telefone: "",
        profissao: "",
        img: "",
        sexo: "",
        equipe: false,
        funcaoEquipe: "",
        data: "",
      },
      sexos: ["Masculino", "Feminino"],
      profissoes: [
        "Outros",
        "Administrador de Banco de Dados",
        "Açougueiro",
        "Acompanhante de Idosos",
        "Acupunturista",
        "Administrador de Empresas",
        "Administrador de Redes",
        "Administrador de Sistemas",
        "Administrador Hospitalar",
        "Advogado",
        "Aeronauta",
        "Agente Comunitário de Saúde",
        "Agente de Defesa Sanitária",
        "Agente de Viagens",
        "Agente Funerário",
        "Agente Penitenciário",
        "Agricultor",
        "Agrônomo",
        "Ajudante de Motorista",
        "Ajudante de Transportes",
        "Alfaiate",
        "Almirante",
        "Almoxarife",
        "Ambientalista",
        "Ambulante",
        "Analista Administrativo",
        "Analista Ambiental",
        "Analista Comercial",
        "Analista Comercial",
        "Analista de Atendimento a Clientes",
        "Analista de Atendimento Comercial",
        "Analista de Banco",
        "Analista de Banco de Dados",
        "Analista de Cargos e Salários",
        "Analista de Cobrança",
        "Analista de Comércio Exterior",
        "Analista de Compras",
        "Analista de Comunicação",
        "Analista de Contabilidade",
        "Analista de Contas a Pagar e Receber",
        "Analista de Controladoria",
        "Analista de Controladoria",
        "Analista de Controle de Qualidade",
        "Analista de Crédito e Cobrança",
        "Analista de Custos",
        "Analista de Departamento Pessoal",
        "Analista de Desenvolvimento de Produto",
        "Analista de Desenvolvimento de Sistemas",
        "Analista de Desenvolvimento Web",
        "Analista de Distribuição",
        "Analista de Ecommerce",
        "Analista de Estoque",
        "Analista de Engenharia Elétrica",
        "Analista de Projetos",
        "Analista Financeiro",
        "Analista de Fiscal",
        "Analista Quómico",
        "Anestesiologista",
        "Angiologista",
        "Antropólogo",
        "Apicultor",
        "Apresentador",
        "Argumentista",
        "Armador",
        "Armeiro",
        "Arquiteto",
        "Arquiteto de Interiores",
        "Arquiteto Paisagista",
        "Arquiteto Urbanista",
        "Arquiteto Projetista",
        "Arquiteto Vendedor",
        "Arquivista",
        "Arrumadeira",
        "Artista de Espetáculo de Diversões",
        "Artista Plástico",
        "Ascensorista",
        "Assessor de Imprensa",
        "Analista de Fundição",
        "Analista de Informática",
        "Analista de Investimentos",
        "Analista de Logóstica",
        "Analista de Loja",
        "Analista de Manutenção",
        "Analista de Manutenção Elétrica",
        "Analista de Marketing",
        "Analista de PCP",
        "Analista de Produção",
        "Analista de Programação",
        "Analista de Publicidade e Propaganda",
        "Analista de Qualidade",
        "Analista de Recrutamento e Seleção",
        "Analista de Recursos Humanos",
        "Analista de Redes",
        "Analista de Relações Públicas",
        "Analista de Representação Comercial",
        "Analista de SAC",
        "Analista de Segurança Patrimonial",
        "Analista de Seguros",
        "Analista de Sistemas",
        "Analista de Suporte Técnico",
        "Analista de Suprimentos",
        "Analista de Tecnologia da Informação (TI)",
        "Analista de Telecomunicações",
        "Analista de Telemarketing Ativo",
        "Analista de Telemarketing Receptivo",
        "Analista de Tesouraria",
        "Analista de Transportes",
        "Analista de Treinamento",
        "Analista de Treinamento Snior",
        "Analista Econômico",
        "Assistente",
        "Astrônomo",
        "Atendente",
        "Atendente de Agência",
        "Atendente Distribuidor",
        "Atleta",
        "Auditor Ambiental",
        "Auditor de Qualidade",
        "Auditor Externo",
        "Auditor Interno",
        "Auxiliar",
        "Auxiliar Juródico",
        "Autônomo",
        "Bartender",
        "Babá",
        "Balconista",
        "Bancário",
        "Barman",
        "Biblioteconista",
        "Biólogo",
        "Biomédico",
        "Bioquómico",
        "Biotecnólogo",
        "Bombeiro",
        "Borracheiro",
        "Cabeleireiro",
        "Cadista",
        "Cardiologista",
        "Cartazista",
        "Carteiro",
        "Cenógrafo",
        "Ceramista",
        "Cineasta",
        "Cinegrafista",
        "Cirurgião Plástico",
        "Clónico Geral",
        "Cobrador de Coletivo",
        "Comissário de Bordo",
        "Confeiteiro",
        "Conferente",
        "Conferente de Loja",
        "Consultor Contábil",
        "Consultor de Marketing",
        "Consultor de Moda",
        "Consultor de Qualidade",
        "Consultor de Vendas Externas",
        "Consultor de Viagens",
        "Contador",
        "Controlador de Tráfego",
        "Coordenador Administrativo",
        "Coordenador Comercial Externo",
        "Coordenador Comercial Interno",
        "Coordenador de Almoxarifado",
        "Coordenador de Arquitetura",
        "Coordenador de Atendimento Comercial",
        "Coordenador de Atendimento a Clientes",
        "Coordenador de Banco",
        "Coordenador de Cargos e Salários",
        "Coordenador de Cobrança",
        "Coordenador de Comércio Exterior",
        "Coordenador de Compras",
        "Coordenador de Comunicação",
        "Coordenador de Contabilidade",
        "Coordenador de Controladoria",
        "Coordenador de Controle de Qualidade",
        "Coordenador de Cozinha",
        "Coordenador de Crédito e Cobrança",
        "Coordenador de Custos",
        "Coordenador de Departamento Pessoal",
        "Coordenador de Desenvolvimento de Produto",
        "Coordenador de Desenvolvimento de Sistemas",
        "Coordenador de Diagramação",
        "Coordenador de Ecommerce",
        "Coordenador de Enfermagem",
        "Coordenador de Engenharia e Segurança do Trabalho",
        "Coordenador de Engenharia Elétrica",
        "Coordenador de Estoque",
        "Coordenador de Fundição",
        "Coordenador de Informática",
        "Coordenador de Jornalismo",
        "Coordenador de Limpeza",
        "Coordenador de Logóstica",
        "Coordenador de Loja",
        "Coordenador de Manutenção",
        "Coordenador de Manutenção Elétrica",
        "Coordenador de Marketing",
        "Coordenador de PCP",
        "Coordenador de Produção",
        "Coordenador de Publicidade e Propaganda",
        "Coordenador de Qualidade",
        "Coordenador de Recrutamento e Seleção",
        "Coordenador de Recursos Humanos",
        "Coordenador de Representação Comercial",
        "Coordenador de SAC",
        "Coordenador de Salão",
        "Coordenador de Segurança Patrimonial",
        "Coordenador de Seguros",
        "Coordenador de Sistemas",
        "Coordenador de Suporte Técnico",
        "Coordenador de Suprimentos",
        "Coordenador de Tecnologia da Informação",
        "Coordenador de Telecomunicações",
        "Coordenador de Telemarketing Ativo",
        "Coordenador de Telemarketing Receptivo",
        "Coordenador de Tesouraraia",
        "Coordenador de Transportes",
        "Coordenador de Treinamento",
        "Coordenador de Usinagem",
        "Coordenador Econômico",
        "Coordenador Financeiro",
        "Coordenador Fiscal",
        "Coordenador Quómico",
        "Corretor de Seguros",
        "Cozinheiro",
        "Diretor Administrativo",
        "Dentista",
        "Desenhista",
        "Designer de Interiores",
        "Designer de Moda",
        "Diagramador",
        "Diretor Comercial Externo",
        "Diretor Comercial Interno",
        "Diretor de Cinema",
        "Diretor de Prdução",
        "Diretor de Representação Comercial",
        "Diretor de Recursos Humanos",
        "Diretor de Tecnologia da Informação (TI)",
        "Diretor de Marketing",
        "Diretor Financeiro",
        "Diretor de Informática",
        "Diretor de Jornalismo",
        "Diretor de Suporte Técnico",
        "Diretor de Logóstica",
        "Diretor de Departamento Pessoal",
        "Ecologista",
        "Economista",
        "Editor",
        "Educador",
        "Eletricista",
        "Eletricista de Manutenção",
        "Embalador",
        "Empreagdo (a) Doméstico (a)",
        "Encanador",
        "Encarregado de Almoxarifado",
        "Encarregado de PCP",
        "Encarregado de Recursos Humanos",
        "Encarregado de Segurança",
        "Encarregado de Transporte",
        "Encarregado de Usinagem",
        "Endocrinologista",
        "Engenheiro Têxtil",
        "Enfermeiro",
        "Engenheiro Aeronáutico",
        "Engenheiro Agrimensor",
        "Engenheiro Agrônomo",
        "Engenheiro Ambiental",
        "Engenheiro Civil",
        "Engenheiro da Computação",
        "Engenheiro de Alimentos",
        "Engenheiro de Engenharia e Segurança do Trabalho",
        "Engenheiro de Produção",
        "Engenheiro de Suprimentos",
        "Engenheiro de Telecomunicações",
        "Engenheiro Eletricista",
        "Engenheiro Metalúrgico",
        "Engenheiro Naval",
        "Engenheiro Nuclear",
        "Estagiário",
        "Esteticista",
        "Estilista",
        "Estoquista",
        "Estoquista de Loja",
        "Fundidor",
        "Farmacêutico",
        "Feirante",
        "Filósofo",
        "Fósico",
        "Fisioterapeuta",
        "Fonoaudiólogo",
        "Fotógrafo",
        "Fresador",
        "Fresador CNC",
        "Fresador Ferramenteiro",
        "Garçom",
        "Gari",
        "Gastrônomo",
        "Geofósico",
        "Geográfo",
        "Geólogo",
        "Gerente Administrativo",
        "Gerente Comercial",
        "Gerente de Atendimento a Clientes",
        "Gerente de Atendimento Comercial",
        "Gerente de Banco",
        "Gerente de Cobrança",
        "Gerente de Comércio Exterior",
        "Gerente de Compras",
        "Gerente de Comunicação",
        "Gerente de Contabilidade",
        "Gerente de Contas",
        "Gerente de Controladoria",
        "Gerente de Controle de Qualidade",
        "Gerente de Cozinha",
        "Gerente de Departamento Pessoal",
        "Gerente de Desenvolvimento de Produto",
        "Gerente de Desenvolvimento de Sistemas",
        "Gerente de Distribuição",
        "Gerente de Ecommerce",
        "Gerente de Enfermagem",
        "Gerente de Engenharia Elétrica",
        "Gerente de Estoque",
        "Gerente de Hotelaria",
        "Gerente de Informática",
        "Gerente de Jornalismo",
        "Gerente de Logóstica",
        "Gerente de Loja",
        "Gerente de Manutenção",
        "Gerente de Manutenção Elétrica",
        "Gerente de Marketing",
        "Gerente de PCP",
        "Gerente de Produção",
        "Gerente de Publicidade e Propaganda",
        "Gerente de Qualidade",
        "Gerente de Recrutamento e Seleção",
        "Gerente de Recursos Humanos",
        "Gerente de Representação Comercial",
        "Gerente de SAC",
        "Gerente de Salão",
        "Gerente de Segurança Patrimonial",
        "Gerente de Seguros",
        "Gerente de Sistemas",
        "Gerente de Suporte Técnico",
        "Gerente de Suprimentos",
        "Gerente de Tecnologia da Informação (TI)",
        "Gerente de Telecomunicações",
        "Gerente de Telemarketing Ativo",
        "Gerente de Telemarketing Receptivo",
        "Gerente de Tesouraria",
        "Gerente de Transportes",
        "Gerente Financeiro",
        "Gerente Fiscal",
        "Gerente Quómico",
        "Geriatra",
        "Gestor Ambiental",
        "Ginecologista",
        "Governanta",
        "Homeopata",
        "Historiador",
        "Inspetor de Controle de Qualidade",
        "Instalador de Acessórios Automotivos",
        "Instalador de Alarmes",
        "Instalador de Cabeamento Estruturado",
        "Instalador de Telecomunicações",
        "Instrutor de Treinamento",
        "Jornalista",
        "Jardineiro",
        "Lóder de Produção",
        "Lóder de Usinagem",
        "Locutor",
        "Maestro",
        "Mandrilhador",
        "Manicure_Pedicure",
        "Manobrista",
        "Maquiador",
        "Marceneiro",
        "Marinheiro",
        "Massagista",
        "Matemático",
        "Mecânico",
        "Mecânico de Automóveis",
        "Mecânico de Manutenção Hidráulica",
        "Médico",
        "MestredeObras",
        "Modelo",
        "Monitor de Atendimento a Clientes",
        "Monitor de Telemarketing",
        "Motoboy",
        "Motorista",
        "Neurologista",
        "Nutricionista",
        "Obstetra",
        "Oftalmologista",
        "Operador de Atendimento a Clientes",
        "Operador de Caixa",
        "Operador de Fundição",
        "Operador de Guilhotina",
        "Operador de Logóstica",
        "Operador de Produção",
        "Operador de SAC",
        "Operador de Telemarketing",
        "Operador de Usinagem",
        "Ortopedista",
        "Otorrinolaringologista",
        "Psicólogo",
        "Padeiro",
        "Pescador",
        "Paisagista",
        "Pediatra",
        "Pedreiro",
        "Pintor",
        "Podólogo",
        "Polidor",
        "Produtor Editorial",
        "Professor",
        "Programadort",
        "Promotor Bancário",
        "Quómico",
        "Recepcionista",
        "Radialista",
        "Radiologista",
        "Redator",
        "Repórter",
        "Representante Comercial",
        "Supervisor Administrativo",
        "Secretária",
        "Serralheiro",
        "Supervisor",
        "Supervisor de Telemarketing",
        "Supervisor Fiscal",
        "Técnico Ambiental",
        "Técnico de Controle de Qualidade",
        "Técnico de Edificações",
        "Técnico de Suporte",
        "Técnico em Manutenção Elétrica",
        "Técnico em Análise Clónica",
        "Técnico em Análise Quómica",
        "Técnico em Automação",
        "Técnico em Guia de Turismo",
        "Técnico em Hardware",
        "Técnico em Metalúrgica",
        "Técnico em Redes",
        "Técnico em Secretariado",
        "Técnico em Secretariado Escolar",
        "Técnico em Transações Imobiliárias",
        "Técnico em Zootecnia",
        "Técnico Instalador",
        "Técnico em Telecomunicações",
        "Tesoureiro",
        "Topógrafo",
        "Tradutor",
        "Traumatologista",
        "Turismólogo",
        "Urologista",
        "Vendedor",
        "Veterinário",
        "Vigilante",
        "Vigilante",
        "Vitrinista",
        "Web Design",
        "Web Design",
        "Zelador",
        "Zootecnista",
      ],
    };
  },
  watch: {
    //aqui fica escutando evento dos objetos :p
    user() {
      this.carregarPerfil();
    },
  },

  mounted() {
    this.chamaOverlay(1000);
  },

  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        this.perfil.email = user.email;
        this.arquivo = firebase.auth().currentUser.photoURL;
      }
    });

    this.geolocate();
  },
  methods: {
    // GOOGLE MAPS
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };

        this.preencheEnderecoCompleto();

        // limpa dados da busca anterior
        this.markers = [];
        this.markers.push({ position: marker });
        this.center = marker;
        // this.currentPlace = null;
      }
    },
    geolocate: function () {
      // marker: marcador/ places: lugares

      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        // alert('lat:'+position.coords.latitude + '  long:'+position.coords.longitude )
        // this.markers.push({ position: { lat: position.coords.latitude, lng: position.coords.longitude} }); //new
      });
    },

    preencheEnderecoCompleto() {
      var NumeroRua;
      var Rua = "";
      var Bairro = "";
      var Cidade = "";
      var Estado = "";

      var ListaEnderecoCompleto = this.currentPlace.address_components;

      ListaEnderecoCompleto.forEach((element) => {
        switch (element.types[0]) {
          case "street_number":
            NumeroRua = element.short_name;
            break;
          case "route":
            Rua = element.short_name;
            break;
          case "sublocality_level_1":
            Bairro = element.short_name;
            break;
          case "administrative_area_level_2":
            Cidade = element.short_name;
            break;
          case "administrative_area_level_1":
            Estado = element.short_name;
            break;

          default:
            break;
        }
      });

      var local = this.currentPlace.address_components[0].types[0]; // aqui que verei oque ele colocoue restringe o nuvel apenas até bairro
      if (
        local != "street_number" &&
        local != "route" &&
        local != "sublocality_level_1"
      ) {
        this.EnderecoPersonalizado = "";
        this.mensagemAlerta("Apenas Ruas e Bairros são permitidos");
        return;
      }

      if (Estado != "MS") {
        this.EnderecoPersonalizado = "";

        this.mensagemAlerta(
          "Apenas endereços de Mato Grosso do Sul são permitidos"
        );
        return;
      }

      this.perfil.bairro = Bairro;
      this.perfil.cidade = Cidade;
      this.perfil.latitude = this.currentPlace.geometry.location.lat();
      this.perfil.longitude = this.currentPlace.geometry.location.lng();

      this.perfil.endereco = Rua + ",  " + (NumeroRua ? NumeroRua : "");
      this.EnderecoPersonalizado =
        this.perfil.endereco + " - " + Bairro + ", " + Cidade + " - " + Estado;
    },
    // GOOGLE MAPS

    //IMGAGEM
    quandoSelecionarImagem() {
      let input = this.$refs.fileInput;
      let files = input.files;
      //valida tamanho img e formato
      var tamanho = files[0].size;
      var formato = files[0].type;

      if (tamanho > 20971520) {
        //20MB
        this.mensagemAlerta("Tamanho máximo permitido: 20Mb");
        return;
      }
      if (formato != "image/jpeg" && formato != "image/png") {
        this.mensagemAlerta("Formato (" + formato + ") não permitido");
        return;
      }
      //valida tamanho img e formato
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.arquivo = e.target.result;
          this.perfil.img = files[0];
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    abrirSelecaoImagem() {
      this.$refs.fileInput.click();
      //  this.arquivo = null;
    },
    //IMAGEM

    //PERSISTENCIA
    async limpaCampos() {
      this.EnderecoPersonalizado = "";
      this.perfil = {
        id: "",
        email: "",
        primeiroNome: "",
        segundoNome: "",
        dataNascimento: "",
        telefone: "",
        profissao: "",
        img: "",
        endereco: "",
        bairro: "",
        cidade: "",
        regiao: "",
        longitude: "",
        latitude: "",
        data: "",
      };
      this.arquivo = null;
      this.fecharAlert();
      // this.resetValidation();
    },
    async resetValidation() {
      this.$refs.form.resetValidation();
    },

    async validaSalvarEditar(perfilID) {
      await this.$refs.form.validate();

      if (this.EnderecoPersonalizado == "" && this.objSlide == 3) {
        this.mensagemAlerta("selecione um endereço");
        return;
      }
      if (!this.valid) {
        this.mensagemAlerta("preencha os campos obrigatórios");
        return;
      }
      this.save(perfilID);
    },
    async save(perfilID) {
      if (!perfilID) {
        await this.salvarPerfil();
        // this.dialogMensagemSalva = false;
      } else {
        await this.atualizarPerfil(perfilID);
      }

      // this.atualizarPerfil = false;
    },

    async salvarPerfil() {
      let aux = "";
      let img = this.perfil.img;
      await firebase
        .firestore()
        .collection("perfil")
        .add({
          id: "",
          email: this.perfil.email,
          primeiroNome: this.perfil.primeiroNome,
          segundoNome: this.perfil.segundoNome,
          sexo: this.perfil.sexo,
          equipe: false,
          funcaoEquipe: this.perfil.funcaoEquipe,
          dataNascimento: this.ConversaoDataSimples(this.perfil.dataNascimento),
          telefone: this.perfil.telefone,
          profissao: this.perfil.profissao,
          img: firebase.auth().currentUser.photoURL,
          endereco: this.perfil.endereco,
          bairro: this.perfil.bairro,
          cidade: this.perfil.cidade,
          longitude: this.perfil.longitude,
          latitude: this.perfil.latitude,
          data: new Date(),
        })
        .then(function (docRef) {
          firebase.firestore().collection("perfil").doc(docRef.id).update({
            id: docRef.id,
          });
          aux = docRef.id;
        });
      // this.dialogPerfil = false;
      //this.chamaOverlay(3000);

      //salva IMG STORAGE
      await storage.ref("perfil").child(aux).put(img);

      var urlAntiga = await storage.ref("perfil").child(aux).getDownloadURL();

      var partes = urlAntiga.split(aux);
      var provavelUrlNova = partes[0] + aux + "_800x800" + partes[1];

      setTimeout(function () {
        firebase.firestore().collection("perfil").doc(aux).update({
          img: provavelUrlNova,
        });
        //window.location.href = "Home";
      }, 3000);
    },
    async atualizarPerfil() {
      firebase
        .firestore()
        .collection("perfil")
        .doc(this.perfil.id)
        .update({
          email: this.perfil.email,
          primeiroNome: this.perfil.primeiroNome,
          segundoNome: this.perfil.segundoNome,
          dataNascimento: this.ConversaoDataSimples(this.perfil.dataNascimento),
          sexo: this.perfil.sexo,
          equipe: this.perfil.equipe,
          funcaoEquipe: this.perfil.funcaoEquipe,
          telefone: this.perfil.telefone,
          profissao: this.perfil.profissao,
          endereco: this.perfil.endereco,
          bairro: this.perfil.bairro,
          cidade: this.perfil.cidade,
          longitude: this.perfil.longitude,
          latitude: this.perfil.latitude,
          data: new Date(),
        });
      this.mensagemAlerta("Operação realizada com sucesso");

      setTimeout(function () {
        window.location.href = "Home";
      }, 2000);
    },

    async atualizarFoto() {
      if (!this.arquivo) {
        this.mensagemAlerta("selecione uma imagem");
        return;
      }
      this.objSlide = 2;
      if (this.arquivo != this.perfil.img && this.perfil.id != "") {
        // se img for alterada e estiver logado
        this.overlay = true;
        const imageRef = storage.ref("perfil").child(this.perfil.id);

        imageRef
          .put(this.perfil.img)
          .then((snapshot) => {
            console.log("esse é o snapshot " + snapshot);
            return imageRef.getDownloadURL().then((url) => {
              var partes = url.split(this.perfil.id);
              var provavelUrlNova =
                partes[0] + this.perfil.id + "_800x800" + partes[1];

              firebase
                .firestore()
                .collection("perfil")
                .doc(this.perfil.id)
                .update({
                  img: provavelUrlNova,
                });
              // url is the download URL

              this.overlay = false;
              this.mensagemAlerta("Foto Alterada com Sucesso");
            });
          })
          .catch((error) => {
            console.log("ERRO Perfil.vue/atualizarFoto()----->> " + error);
          });
      }
    },

    //PERSISTENCIA
    async mensagemAlerta(msg) {
      this.fecharAlert();
      this.msgAlert = "\n" + msg + "\n";
      this.alert = true;
    },
    fecharAlert() {
      this.alert = false;
      this.msgAlert = "";
    },
    deslogarUsuario() {
      if (this.perfil.id == "") {
        firebase.auth().signOut();
      }
      window.location.href = "Home";
    },

    async carregarPerfil() {
      if (firebase.auth().currentUser.email) {
        await firebase
          .firestore()
          .collection("perfil")
          .where("email", "==", firebase.auth().currentUser.email)
          .onSnapshot((snap) => {
            snap.forEach((doc) => {
              this.perfil = doc.data();
              // this.perfil.dataNascimento = this.perfil.dataNascimento;
              this.arquivo = this.perfil.img;

              const marker = {
                lat: this.perfil.latitude,
                lng: this.perfil.longitude,
              };

              this.markers = [];
              this.markers.push({ position: marker });

              this.center = marker;

              this.EnderecoPersonalizado =
                this.perfil.endereco + " - " + this.perfil.bairro; // limpa dados da busca anterior
            });
          });
      }
    },

    ConversaoDataSimples(data) {
      //vem do banco em dateTime
      var dataFormatada = data.split("/");
      return dataFormatada[0] + "/" + dataFormatada[1] + "/" + dataFormatada[2];
    },

    // MELHORAR DEPOIS CONVERSAO DE DATAS
    // FormataDataTimesTampParaString(data) {
    //   //vem do banco em dateTime

    //   return moment.unix(data.seconds).format("DD/MM/YYYY");
    // },
    // FormataDataStringParaTimesTamp(data) {
    //   //vem do banco em dateTime
    //   var dataFormatada = data.split("/");
    //   return new Date(dataFormatada[0], dataFormatada[1] - 1, dataFormatada[2]);
    // },

    async chamaOverlay(val) {
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      }, val);
    },
  },
};
</script>

<style scoped>
.v-text-field {
  border: 50px;
}
/* ESTILO SÒ PARA ABRIR A IMAGEM POR ENQUANTO */

.base-image-input {
  /*  altera tamanho da foto */
  width: 180px;
  height: 155px;

  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholder:hover {
  background: #e0e0e0;
}
.file-input {
  display: none;
}

/* ESTILO SÒ PARA ABRIR A IMAGEM POR ENQUANTO */
</style>
